"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
    onCreate: function () {
        this.state = {
            scope: {
                type: null,
                page: {},
                ancestors: [],
                themeMode: 'light'
            },
            contextModal: null
        };
        GState.bind(this, [
            'public',
            'skeleton',
            'tenant',
            'user'
        ]);
        this.state.scope.themeMode = this.state.user ? this.state.user.settings.theme.mode : 'light';
    },
    onInput: function () {
        if (!this.state.skeleton)
            return;
        this.state.scope.type = (this.state.skeleton.type || '').toLowerCase();
        const [nan, verb, id] = location.pathname.split('/'), pageName = verb.replace('-', '_'), page = !pageName ? this.state.skeleton.pages.welcome || this.state.skeleton.pages.home || this.state.skeleton.pages.dashboard || this.state.public.home : this.state.skeleton.pages[pageName] || this.state.public[pageName];
        this.state.scope.page = page;
        GState.workspace.context({
            page: pageName || (this.state.skeleton.pages.welcome ? 'welcome' : 'home'),
            event: { id },
            keywords: page.keywords
        });
        if (page.parent)
            this.state.scope.ancestors = this.getAncestors(page.parent);
    },
    getAncestors: function (parentName, Ancestors = []) {
        const parentSet = this.state.skeleton.pages[parentName];
        Ancestors.unshift(parentSet);
        if (parentSet.parent)
            return this.getAncestors(parentSet.parent, Ancestors);
        return Ancestors;
    },
    onModalOpen: function (ctxt) {
        this.state.contextModal = ctxt;
    },
    onModalSelect: function ({label, value, fn}) {
        if (!fn)
            return console.log(`[Context-Modal] Expected a return function for <${ label }>`);
        typeof fn == 'function' && fn(value);
    },
    onModalDismiss: function () {
        this.state.contextModal = null;
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/Wrapper/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    ContextModal_template = require("../ContextModal/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    ContextModal_tag = marko_loadTag(ContextModal_template),
    set_context_template = require("@marko-tags/context/src/components/set-context/index.marko"),
    set_context_tag = marko_loadTag(set_context_template);

function render(input, out, __component, component, state) {
  var data = input;

  set_context_tag(marko_assign({}, state.scope, {
      __from: module.exports,
      renderBody: function(out) {
        out.be("div", {
            id: state.scope.page.title,
            "class": "position-relative vh-100 theme-bg"
          }, "0", component, null, 1);

        if ((state.tenant && state.tenant.settings.learners) && state.tenant.settings.learners.bgImage) {
          out.e("div", {
              style: marko_styleValue(("background:url('" + state.tenant.logo) + "');background-size:cover;"),
              "class": "position-absolute w-100 h-100 zindex-1"
            }, "1", component, 0, 1);
        }

        out.be("div", {
            "class": marko_classValue(marko_classValue([
              "position-relative container h-100 p-0 zindex-2 theme-bg-transparent",
              (input.class + " ") + (input.scroll ? "overflow-auto" : "")
            ]))
          }, "2", component, null, 1);

        marko_dynamicTag(out, input.renderBody, function() {
          return state.scope;
        }, null, null, null, __component, "3");

        out.ee();

        out.ee();

        if (state.contextModal) {
          ContextModal_tag(marko_assign({
              options: []
            }, state.contextModal), out, __component, "4", [
            [
              "select",
              "onModalSelect",
              false
            ],
            [
              "dismiss",
              "onModalDismiss",
              false
            ]
          ]);
        }
      }
    }), out, __component, "5", [
    [
      "open",
      "onModalOpen",
      false
    ]
  ]);
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
